import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router does not scroll to hash targets on navigation, so links like
 * "/#offer" coming from the policy pages would land at the top of the page.
 * This waits for the target to exist (the landing page mounts large images
 * first) and then scrolls it into view on every device.
 */
export function ScrollToHash() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    let timer = 0;
    const attempt = (tries: number) => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
      if (tries < 25) {
        timer = window.setTimeout(() => attempt(tries + 1), 80);
      }
    };
    timer = window.setTimeout(() => attempt(0), 0);
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);
  return null;
}